import * as React from "react";
import { getUserSubordinates } from "../../libs/user";
import EmployeeList from "./EmployeeList";

interface IProps {
  user: IUser;
}

interface IState {
  subordinates: IUser[];
}

class UserSubordinatesList extends React.Component<IProps, IState> {
  state: IState = { subordinates: [] };

  async componentDidMount() {
    const subordinates = await getUserSubordinates(this.props.user.id);
    this.setState({ subordinates });
  }

  render() {
    return (
      <EmployeeList employees={this.state.subordinates} showRoles={true} />
    );
  }
}

export default UserSubordinatesList;



// WEBPACK FOOTER //
// ./app/javascript/components/employee/EmployeeSubordinatesList.tsx